export const fromLongToShort = {
  ar_AE: 'ar',
  de_DE: 'de',
  en_US: 'en',
  es_ES: 'es',
  fr_FR: 'fr',
  hi_IN: 'hi',
  hu_HU: 'hu',
  id_ID: 'id',
  it_IT: 'it',
  ja_JP: 'ja',
  ko_KO: 'ko',
  pl_PL: 'pl',
  pt_PT: 'pt',
  ro_RO: 'ro',
  ru_RU: 'ru',
  tr_TR: 'tr',
  vi_VN: 'vi',
  zh_ZH: 'zh',
  uz_UZ: 'uz',
  ky_KY: 'ky',
  fil_FIL: 'fil',
  uk_UA: 'uk',
  he_IL: 'he',
  es_MX: 'esmx',
  fa_IR: 'fa',
  th_TH: 'th',
  af_ZA: 'af',
  ur_PK: 'ur',
  bn_BD: 'bn',
  ta_IN: 'ta',
  mr_IN: 'mr',
  gu_IN: 'gu',
  te_IN: 'te',
  bg_BG: 'bg',
  sk_SK: 'sk',
  cs_CZ: 'cs',
  sr_RS: 'sr',
  hr_HR: 'hr',
  zu_ZA: 'zu',
  sl_SI: 'sl',
  mk_MK: 'mk',
  sq_AL: 'sq',
  xh_ZA: 'xh',
  pt_BR: 'ptbr'
};

export const fromShortToLong = {
  ar: 'ar_AE',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
  zh: 'zh_ZH',
  ky: 'ky_KY',
  uz: 'uz_UZ',
  fil: 'fil_FIL',
  uk: 'uk_UA',
  he: 'he_IL',
  esmx: 'es_MX',
  fa: 'fa_IR',
  th: 'th_TH',
  af: 'af_ZA',
  ur: 'ur_PK',
  bn: 'bn_BD',
  ta: 'ta_IN',
  mr: 'mr_IN',
  gu: 'gu_IN',
  te: 'te_IN',
  bg: 'bg_BG',
  sk: 'sk_SK',
  cs: 'cs_CZ',
  sr: 'sr_RS',
  hr: 'hr_HR',
  zu: 'zu_ZA',
  sl: 'sl_SI',
  mk: 'mk_MK',
  sq: 'sq_AL',
  xh: 'xh_ZA',
  ptbr: 'pt_BR'
};

export const sourceLanguagesForAll = {
  ar: 'ar_AE',
  de: 'de_DE',
  es: 'es_ES',
  en: 'en_US',
  fr: 'fr_FR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KO',
  pt: 'pt_PT',
  pl: 'pl_PL',
  ro: 'ro_RO',
  ru: 'ru_RU',
  tr: 'tr_TR',
  vi: 'vi_VN',
  zh: 'zh_ZH',
  fil: 'fil_FIL',
  ky: 'ky_KY',
  uz: 'uz_UZ',
  uk: 'uk_UA',
  he: 'he_IL',
  esmx: 'es_MX',
  fa: 'fa_IR',
  th: 'th_TH',
  af: 'af_ZA',
  ur: 'ur_PK',
  bn: 'bn_BD',
  ta: 'ta_IN',
  mr: 'mr_IN',
  gu: 'gu_IN',
  te: 'te_IN',
  bg: 'bg_BG',
  sk: 'sk_SK',
  cs: 'cs_CZ',
  sr: 'sr_RS',
  hr: 'hr_HR',
  zu: 'zu_ZA',
  sl: 'sl_SI',
  mk: 'mk_MK',
  sq: 'sq_AL',
  xh: 'xh_ZA',
  ptbr: 'pt_BR'
};

// Regional variants that belong to the same language. A lesson must not be
// started from any source language that shares the target's group (e.g. a
// Spanish lesson can't start from es or esmx).
export const languageVariantGroups = [
  ['es', 'esmx'],
  ['pt', 'ptbr']
];

// Target languages that may be started from their own source language.
// English lessons are allowed to run with an English source.
export const targetLanguagesAllowingSameSource = ['en'];

// Returns the source language codes that must be blocked for the given target
// language. English allows a same-language source; every other target blocks
// itself (and its regional variants).
export const getBlockedSourceLanguages = targetLanguage => {
  if (!targetLanguage) {
    return [];
  }
  if (targetLanguagesAllowingSameSource.includes(targetLanguage)) {
    return [];
  }
  const variantGroup = languageVariantGroups.find(group =>
    group.includes(targetLanguage)
  );
  return variantGroup || [targetLanguage];
};

const detectSubDomain = () => {
  try {
    const full = window.location.host;
    // window.location.host is subdomain.domain.com
    const parts = full.split('.');
    const sub = parts[0];
    return sub;
  } catch (e) {
    return undefined;
  }
};

// Detect subdomain and after browser language
export const detectBrowserLanguage = () => {
  const subDomain = detectSubDomain();

  if (subDomain && subDomain.length === 2) {
    return fromShortToLong[subDomain];
  }
  let locale = navigator.language;
  if (locale) {
    locale = locale.split('-')[0];
    locale = fromShortToLong[locale];
  }
  if (!locale) {
    locale = 'en_US';
  }
  return locale;
};



// WEBPACK FOOTER //
// ./src/components/shared/languageCodes.js